declare const gtag : (context : string, action : string, options: {
  ad_storage: string;
  analytics_storage: string;
}) => undefined;

const updateTagManagerConsent = (granted : boolean) => {
  const value = granted ? 'granted' : 'denied';

  gtag('consent', 'update', {
    ad_storage: value,
    analytics_storage: value,
  });
};

export default updateTagManagerConsent;
